const state = {
    generos: [
        { id: 1, name: "Hombre" },
        { id: 2, name: "Mujer" },
        { id: 3, name: "Otros" }
    ]
}

const getters = {
    getGeneros: state => {
        return state.generos;
    }
}

const mutations = {
    setGeneros: (state, generos) => {
        state.generos = generos;
    }
}

const actions = {
    SELECT_GENEROS_CDN: function({ commit, state }) {
        return Promise.resolve({ data: { data: state.generos } });
    }
}

export default {
    state,
    actions,
    getters,
    mutations
};